/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const VerticalAlignTopIcon = /*#__PURE__*/ createSvgIcon(
  'VerticalAlignTopIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M4.756 4.5a.738.738 0 01-.537-.214A.714.714 0 014 3.754c0-.21.072-.39.215-.535A.72.72 0 014.75 3h10.494c.212 0 .391.071.537.214.146.143.219.32.219.532 0 .21-.072.39-.215.535a.72.72 0 01-.535.219H4.756zM10.004 17a.734.734 0 01-.535-.216.72.72 0 01-.219-.534V8.875l-1.667 1.646a.729.729 0 01-1.062 0A.718.718 0 016.29 10c0-.194.076-.367.227-.518l2.961-2.961a.756.756 0 01.525-.208c.1 0 .194.017.281.052a.69.69 0 01.236.156l2.942 2.942a.729.729 0 01-.004 1.058.758.758 0 01-.522.24.681.681 0 01-.52-.22L10.75 8.876v7.375c0 .212-.072.39-.214.534a.72.72 0 01-.532.216z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default VerticalAlignTopIcon;
